<!-- <mat-card class="flex flex-col flex-auto w-full p-6 "> -->
  <div class="flex flex-col flex-auto w-full  round-2xl m-4 p-4">
<div class="mat-row">
  <div class="mat-col-lg-12 mat-col-md-12">
    <button mat-flat-button color="primary" style="float:right; padding: 7px; border-radius: 2px;" class="bg-blue-500 text-white"  (click)="crtetckt()"> Create Ticket</button>
  </div>
</div>
<div *ngIf="tcktsLst">
  <div class="p-4" *ngFor="let n of tcktsLst">
    <div class="mb-6 bg-card shadow-lg rounded-lg">
      <div class="p-6">
        <div class="flex flex-col">
          <p class="text-lg font-bold">
            Ticket Id: {{n.tckt_id}}
          </p>
          <div class="tmplteDescrptn">
            Status :
              <div *ngIf="n.tckt_status_id == 1"
              class="status_text new text-center p-4 mb-12 border-bottom-right-radius-5 border-top-right-radius-5 maxwdt">
              <span class="StSp">{{n.tckt_sts_nm}}</span></div>
            <div *ngIf="n.tckt_status_id == 2"
              class="status_text open text-center p-4 mb-12 border-bottom-right-radius-5 border-top-right-radius-5 maxwdt">
              <span class="StSp">{{n.tckt_sts_nm}}</span></div>
            <div *ngIf="n.tckt_status_id == 3"
              class="status_text onHold text-center p-4 mb-12 border-bottom-right-radius-5 border-top-right-radius-5 maxwdt">
              <span class="StSp">{{n.tckt_sts_nm}}</span></div>
            <div *ngIf="n.tckt_status_id == 4"
              class="status_text sloved text-center p-4 mb-12 border-bottom-right-radius-5 border-top-right-radius-5 maxwdt">
              <span class="StSp">{{n.tckt_sts_nm}}</span></div>
            <div *ngIf="n.tckt_status_id == 5"
              class="status_text closed text-center p-4 mb-12 border-bottom-right-radius-5 border-top-right-radius-5 maxwdt">
              <span class="StSp">{{n.tckt_sts_nm}}</span></div>
            <div *ngIf="n.tckt_status_id == 6"
              class="status_text slabreached text-center p-4 mb-12 border-bottom-right-radius-5 border-top-right-radius-5 maxwdt">
              <span class="StSp">{{n.tckt_sts_nm}}</span></div>
            <div *ngIf="n.tckt_status_id == 7"
              class="status_text slabreached text-center p-4 mb-12 border-bottom-right-radius-5 border-top-right-radius-5 maxwdt">
              <span class="StSp">{{n.tckt_sts_nm}}</span></div>
            <div style="font-size:14 ;font-weight:500 ;margin-top:20px ">{{n.dscn_tx}}</div>

            <button mmat-stroked-button  color="accent"  class="mt-4 " (click)="viewDtls(n)" style="font-size: 13px;
            border: 1px solid #c3c3c3;
            border-radius: 20px;
            padding: 2px 12px;
            float: right;">
              <mat-icon style="font-size: 14px;
              color: #0d96e2;
              vertical-align: -2px;">edit</mat-icon>Edit
            </button>
          </div>
        </div>
        <hr class="my-4">
        <div class="flex flex-wrap mt-4" style="    justify-content: space-around;">
          <div class="w-full md:w-auto">Created by: {{n.createuser}}</div>
          <div class="w-full md:w-auto md:ml-8">Created On: {{n.tckt_dt}}</div>
          <div class="w-full md:w-auto md:ml-8">Last Updated On: {{n.u_ts}}</div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
